import * as React from 'react';

import { cn } from 'shared/lib/utils';

function Footnote({
  className,
  children = undefined,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div data-slot="footnote" className={cn('bg-white', className)} {...props}>
      <div className="relative mx-auto -mb-2.5 h-[0.75em] w-[1em] bg-inherit text-center text-4xl leading-12 text-accent">
        *
      </div>
      <div className="mx-auto rounded-lg border-2 border-accent/60 px-3.75 pt-5.5 pb-4.75 text-sm font-normal text-gray-body-copy">
        {children}
      </div>
    </div>
  );
}

function FootnoteIndicator({
  className,
  ...props
}: React.ComponentProps<'span'>) {
  return (
    <span
      data-slot="footnote-indicator"
      className={cn('text-accent', className)}
      {...props}
    />
  );
}

export { Footnote, FootnoteIndicator };
